import React from "react";
import { Link, OutlinedInput, Stack, SxProps } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useTranslation } from "react-i18next";

export interface CommentFormProps {
  sx?: SxProps;
  onSend: (comment: string) => void;
}

const CommentForm: React.FC<CommentFormProps> = ({ onSend, sx = {} }) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState("");
  const minLength = 1;

  const handleCommentChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
  };

  const handleSendClick = () => {
    if (value.length >= minLength) {
      onSend(value);
      setValue("");
    }
  };

  return (
    <Stack sx={sx}>
      <OutlinedInput
        id="comment"
        size="medium"
        placeholder={t("field:placeholder.typeCommentHere")}
        value={value}
        onChange={handleCommentChange}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            handleSendClick();
          }
        }}
      />
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%" }} mt={1} mb={1}>
        <Stack direction="row" alignItems="center">
          {/*
          <IconButton>
            <InsertEmoticonOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton>
            <AlternateEmailIcon fontSize="small" />
          </IconButton>
          <IconButton>
            <LinkIcon fontSize="small" />
          </IconButton>*/}
        </Stack>
        <Link
          underline="hover"
          variant="button"
          color={value.length <= minLength ? "text.tier" : "white"}
          onClick={handleSendClick}
        >
          {t("common:send")}
          <SendIcon fontSize="small" sx={{ ml: 1 }} />
        </Link>
      </Stack>
    </Stack>
  );
};

export default CommentForm;
